// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Global reset styles
const globalStyles = document.createElement("style");
globalStyles.textContent = `
  *, *::before, *::after { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; }
  body { background: #070910; }
  a { color: inherit; }
  button { font-family: inherit; }
  input, textarea, select { font-family: inherit; }
  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: #0d0f18; }
  ::-webkit-scrollbar-thumb { background: #1a1f2e; border-radius: 3px; }
  ::-webkit-scrollbar-thumb:hover { background: #00d4ff44; }
`;
document.head.appendChild(globalStyles);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);